import { render, staticRenderFns } from "./ImportDoc.vue?vue&type=template&id=bb47f396&"
import script from "./ImportDoc.vue?vue&type=script&lang=js&"
export * from "./ImportDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports